<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemContainerMode} from "@/modules/redactor/models/item/ItemContainerMode";

export default {
  name: "r-item-container-mode",
  props: {
    model: VueTypes.instanceOf(ItemContainerMode),
    label: VueTypes.string.def("Container Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemContainerMode.getValues();
    }
  }
}

</script>